<template>
    <form @submit.prevent="submitForm" class=""  method="POST" enctype="">
      <input type="hidden" name="" value="">
      <div class="bg-white mb-2">
        <div class="form-shadow">
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group" id="sells-s">
                <label>Name</label>
                <input type="text" class="form-control rounded-0 sel-control" v-model="formData.name" placeholder="Enter Your Name" name="name" required>
              </div>
            </div>
            <div class="col-lg-12" id="sells-s">
              <div class="form-group">
                <label>Mobile Number</label>
                <input type="text" class="form-control rounded-0 sel-control" v-model="formData.mobile" placeholder="Enter Your mobile Number" name="mobile" required>
              </div>
            </div>
            <div class="col-lg-12" id="sells-s">
              <div class="form-group">
                <label>Email Address</label>
                <input type="email" class="form-control rounded-0 sel-control" v-model="formData.email" placeholder="Enter Your Email" name="email" required>
              </div>
            </div>
            <div class="col-12-6" id="sells-s">
              <div class="form-group">
                <label>Password</label>
                <input type="password" class="form-control rounded-0 sel-control" v-model="formData.password" placeholder="Enter Your Password" name="password" required>
              </div>
            </div>
            <div class="custom-control custom-checkbox mr-sm-2">
              <input type="checkbox" name="remember" class="custom-control-input" id="remember" v-model="formData.agree" required>
              <label class="custom-control-label" for="remember">I agree to PetBacker's <span class="terms-text">Terms of Service</span> </label>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button type="submit" class="btn btn-primary fw-600 rounded-0 reg-btn">SIGN UP</button>
      </div>
      <div class="already-text">
        <p>Already have a RC Pet Resort account? <router-link to="{{route('frontend.login')}}"><span> Log in</span></router-link></p>
      </div>
    </form>
</template>

<script setup>
import { ref } from 'vue';
import * as yup from 'yup';
import { useForm } from 'vee-validate';
import axios from 'axios';
import { register, login } from '../constant/auth.js';



const validationSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  mobile: yup.mixed().required('mobile number is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  password: yup.string().required('Password is required'),
  agree: yup.boolean().oneOf([true], 'You must agree to terms'),
});
const { handleSubmit: veeHandleSubmit, errors } = useForm({
  validationSchema,
  initialValues: {
    name:'',
    mobile: '',
    email: '',
    password: '',
    agree: false,
  }
})
const formData = ref({
  name: '',
  mobile: '',
  email: '',
  password: '',
  agree: false,
});
const registerRoute = register();
const {path, method} = registerRoute;
const loginRoute = login();

const submitForm = async() => {
  try{
    const response = await axios.post(path, formData.value);
    if(response){
      window.location.href = loginRoute.form;
      window.successSnackbar("Registered Successfully")
    }
  }catch(error){
    console.log(error);
  }
};
</script>
